import { Button, Checkbox, Empty, Message, Space, Spin } from '@arco-design/web-react'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import piliangImg from '@/assets/comment/piliang.png'
import msgImg from "@/assets/comment/air.png";
import './CommentList.less'
import { deleteCommentApi, getChildListApi, getCommentListApi, postCommentApi } from '@/services/YsApi/commentManage';
import { isToday, isYesterday } from '@/pages/messageManage/components/Chat/Chat';
import dayjs from 'dayjs';
import { formatTimeAgo, isThisYear, isTowAgoDay } from '../../utils';
import { IconArrowDown, IconDelete, IconDown, IconPlayArrowFill, IconSync, IconUp } from '@arco-design/web-react/icon';
import FormModal from '@/components/FormModal';
import ModalTip from "@/assets/images/modal-tip.png";
const formatTime = (date) => {
  if (isToday(date)) {
    return formatTimeAgo(date)
  } else if (isTowAgoDay(date)) {
    return '前天'
  } else if (isYesterday(date)) {
    return `昨天 ${dayjs(date).format('HH:mm')}`
  } else if (isThisYear(date)) {
    return dayjs(date).format('MM-DD HH:mm')
  } else {
    return dayjs(date).format('YYYY-MM-DD HH:mm')
  }
}

export default function CommentList({ third_uid, aweme_id, num, auth_data, team_id }) {
  const [dataSource, setDataSource] = useState([
  ])
  const [childList, setChildList] = useState({
  })
  const containerRef = useRef(null);
  const [description, setDescription] = useState('')
  const cursor = useRef('0')
  // const [total, setTotal] = useState(0)
  const [hasMore, setHasMore] = useState(true)
  const [loading, setLoading] = useState(false)
  const [sendLoading, setSendLoading] = useState(false)
  const [cid, setCid] = useState('') //单个回复cid
  const [subCid, setSubCid] = useState('')
  const [cids, setCids] = useState([]);
  const [subCids, setSubCids] = useState([])
  const [singleFlag, setSingleFlag] = useState(true);
  const [mulpleFlag, setMulpleFlag] = useState(false);
  const paramsObj = useRef({});
  const [expandLoading, setExpandLoading] = useState<any>({})
  const [refreshLoading, setRefreshLoading] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const inputRef = useRef(null)
  const handleSingleReply = (row, subRow = { cid: '', user: { nickname: '' } }) => {
    inputRef.current?.focus()
    setSingleFlag(true)
    const userName = subRow?.user?.nickname ? subRow?.user?.nickname : row?.user?.nickname
    setDescription(`回复${userName}`)
    setCids([])
    setSubCids([])
    setCid(row.cid)
    setSubCid(subRow.cid)
  }
  const [textValue, setTextValue] = useState('')
  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSend()
    } else if (e.key === 'Backspace' && !e.target.value) {
      setCids([])
      setSubCids([])
      setCid('')
      setDescription('')
    }
  }
  const handleConfirmDelete = () => {
    setConfirmLoading(true)
    Promise.all([...cids.map(item => deleteCommentApi({ cid: item.cid, third_uid, team_id })), ...subCids.map(item => deleteCommentApi({ cid: item.subCid, third_uid, team_id }))]).then(() => {
      Message.success('删除成功')
      setTimeout(() => {
        setConfirmLoading(false)
        setDeleteVisible(false)
        getData()
      }, 1000)
    }).catch(() => {
      setConfirmLoading(false)
    })

  }
  const handleSend = () => {
    if (sendLoading) return;
    if (!textValue) {
      Message.error("请输入发送内容")
      return;
    }
    setSendLoading(true)
    if (singleFlag && description) {
      postCommentApi({
        third_uid,
        text: textValue,
        items: [
          { aweme_id, reply_to_comment_ids: subCid || cid },
        ],
        team_id
      }).then(() => {
        Message.success(`发送成功`)
        setTimeout(() => {
          setSendLoading(false)
          getData()
        }, 1000)
      }).catch((err) => {
        Message.error(err?.message || '评论失败')
        setSendLoading(false)
      })
    } else if (mulpleFlag && mulpleDesc) {
      const list = [...cids, ...subCids]?.filter(i => i.cid)
      if (!list.length) return;
      postCommentApi({
        third_uid,
        text: textValue,
        items: list?.map(i => {
          return { aweme_id, reply_to_comment_ids: i.subCid || i.cid }
        }),
        team_id
      }).then(() => {
        Message.success(`发送成功`)
        setTimeout(() => {
          getData()
          setSendLoading(false)
        }, 1000)
      }).catch(err => {
        Message.error(err?.message || '评论失败')
        setSendLoading(false)
      })
    } else {
      postCommentApi({
        third_uid,
        items: [{
          aweme_id,
          reply_to_comment_ids: ''
        }],
        text: textValue,
        team_id
      }).then(() => {
        Message.success(`发表评论成功`)
        setTimeout(() => {
          getData()
          setSendLoading(false)
        }, 1000)
      }).catch(err => {
        Message.error(err?.message || '评论失败')
        setSendLoading(false)
      })
    }
  }
  const handleSelect = (item) => {
    if (cids.find(i => i.cid === item.cid)) {
      setCids(cids.filter(i => i.cid !== item.cid))
    } else {
      setCids([...cids, { cid: item.cid, nickname: item?.user?.nickname }])
    }
  }
  const handleChildSelect = (cid, row) => {
    setSingleFlag(false)
    setMulpleFlag(true)
    if (subCids.find(i => i.subCid === row.cid)) {
      setSubCids(subCids.filter(c => c.subCid !== row.cid))
    } else {
      setSubCids([...subCids, { cid, subCid: row.cid, nickname: row?.user?.nickname }])
    }
  }
  const mulpleDesc = useMemo(() => {
    const list = [...cids, ...subCids]?.filter(i => i.cid)
    if (list.length < 1) {
      return ''
    } else if (list.length === 1) {
      return `回复${list[0].nickname}`
    } else {
      return `回复${list[0].nickname}...等${list.length}条评论`
    }
  }, [cids, subCids])
  const handleOpenDeleteMulple = () => {
    console.log('删除')
    const list = [...cids, ...subCids]?.filter(i => i.cid)
    if (!list.length) {
      Message.error('请勾选要删除的评论')
    } else {
      setDeleteVisible(true)
      console.log(list, 'list')
    }
  }
  const handleOpenMulple = () => {
    setSingleFlag(false)
    setMulpleFlag(true)
  }
  const handleExpandChild = (row) => {
    if (expandLoading[row.cid]) return;
    setExpandLoading({
      ...expandLoading,
      [row.cid]: true
    })
    getChildListApi({
      third_uid,
      aweme_id,
      c_id: row.cid,
      cursor: childList[row.cid]?.cursor ? String(childList[row.cid]?.cursor) : '0',
      count: 10,
      team_id
    }).then(res => {
      console.log(res.data, 'res.data')
      setChildList({
        ...childList,
        [row.cid]: {
          cursor: res.data.cursor,
          has_more: res.data.has_more,
          list: childList[row.cid]?.cursor ? [...childList[row.cid].list, ...(res.data?.comment || [])] : (res.data?.comment || [])
        }
      })
    }).finally(() => {
      setExpandLoading({
        ...expandLoading,
        [row.cid]: false
      })
    })
  }
  const handleCollapse = (row) => {
    setChildList({
      ...childList,
      [row.cid]: {
        cursor: 0,
        has_more: false,
        list: []
      }
    })
  }
  const handleReset = () => {
    paramsObj.current = {}
    setTextValue('')
    cursor.current = '0'
    setDataSource([])
    setChildList({})
    setCids([])
    setSubCids([])
    setDescription('')
    // setTotal(0)
    setCid('')
    setSingleFlag(true)
    setMulpleFlag(false)
  }
  const getData = () => {
    handleReset()
    setLoading(true)
    const params = {
      third_uid,
      aweme_id,
      cursor: '0',
      count: 10,
      team_id
    }
    paramsObj.current = params
    getCommentListApi(params).then(res => {
      if (JSON.stringify(params) === JSON.stringify(paramsObj.current)) {
        setDataSource(res.data?.comments || [])
        console.log(res.data, ';l;')
        cursor.current = res.data.cursor
        // setTotal(res.data.total)
        setHasMore(true)
      }
    }).catch(() => {
      setDataSource([])
      cursor.current = '0'
      // setTotal(0)
      setHasMore(true)
    }).finally(() => {
      setLoading(false)
      setRefreshLoading(false)
    })
  }
  const handleRefresh = () => {
    setRefreshLoading(true)
    getData()
  }
  useEffect(() => {
    if (aweme_id && third_uid) {
      getData()
    } else {
      handleReset()
    }
  }, [third_uid, aweme_id])
  const handleScroll = useCallback(() => {
    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

    // 判断是否触底
    if (scrollTop + clientHeight >= scrollHeight) {
      if (dataSource.length && !hasMore) return;
      getCommentListApi({
        third_uid,
        aweme_id,
        cursor: String(cursor.current),
        count: 10,
        team_id
      }).then(res => {
        setDataSource([...dataSource, ...(res.data?.comments || [])])
        cursor.current = res.data?.cursor || '0'
        // setTotal(res.data.total)
        if (!res.data?.comment) setHasMore(false)
      })
    }
  }, [dataSource]);
  useEffect(() => {
    const container = containerRef.current;

    // 添加滚动事件监听
    container.addEventListener('scroll', handleScroll);

    // 清除事件监听
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [dataSource]);
  console.log(subCid, cid);

  return (
    <div className="matrix-comment-list">
      <div className="comment-header">
        <div className="comment-header-left">
          <div className="comment-num">评论({num})</div>
          {/* <div><Checkbox>只看未回复评论</Checkbox></div> */}
          <Button disabled={!aweme_id} style={{ height: '30px', borderRadius: '6px' }} icon={<IconSync />} onClick={handleRefresh} loading={refreshLoading}>刷新</Button>
        </div>
        <Space>
          <Button
            className="comment-btn"
            type={"outline"}
            icon={<IconDelete style={{ fontSize: '14px', marginRight: '-7px' }} />}
            onClick={handleOpenDeleteMulple}
            disabled={![...cids, ...subCids].length}
          >
            删除
          </Button>
          <Button
            className="comment-btn"
            type={"primary"}
            icon={<img src={piliangImg} style={{ width: '14px', height: '14px', margin: '0 2px -2px 0' }} />}
            onClick={handleOpenMulple}
            disabled={![...cids, ...subCids].length}
          >
            批量回复
          </Button>
        </Space>
      </div>
      <div className="comment-list" ref={containerRef}>
        {
          dataSource.map(item => {
            return (
              <div key={item.cid}>
                <div className="comment-box">
                  <div className="comment-checked"><Checkbox checked={cids.some(c => c.cid === item.cid)} onClick={() => handleSelect(item)}></Checkbox></div>
                  <div className="comment-avatar"><img src={item?.user?.avatar_168x168?.url_list?.[0] || ''} alt="" /></div>
                  <div className="comment-content">
                    <div className="content-top">
                      <div className="content-user">{item?.user?.nickname}</div>
                      {item.label_text === '作者' && <div className="user-tag">作者</div>}
                    </div>
                    <div className="content-text">{item.text}</div>
                    {item.image_list && <div className="content-img"><img src={item?.image_list?.[0]?.medium_url?.url_list?.[0]} alt="" /></div>}
                    <div className="content-operate">
                      <span className="content-time">{formatTime(item.create_time * 1000)} · {item.ip_label}</span>
                      <span className="reply" onClick={() => handleSingleReply(item)}>回复</span>
                    </div>
                  </div>
                </div>
                {
                  childList[item.cid]?.list?.map(child => {
                    let toUserName = ''
                    if (child.reply_to_reply_id !== '0') {
                      const obj = childList[item.cid]?.list.find(ii => ii.cid === child.reply_to_reply_id)
                      toUserName = obj?.user?.nickname
                    }
                    return (
                      <div className="comment-box" style={{ marginLeft: '50px' }} key={child.cid}>
                        <div className="comment-checked"><Checkbox checked={subCids.some(c => c.subCid === child.cid)} onClick={() => handleChildSelect(item.cid, child)}></Checkbox></div>
                        <div className="comment-avatar"><img style={{ width: '18px', height: '18px' }} src={child?.user?.avatar_thumb?.url_list?.[0] || ''} alt="" /></div>
                        <div className="comment-content">
                          <div className="content-top">
                            <div className="content-user">{child?.user?.nickname}</div>
                            {child?.label_text === '作者' && <div className="user-tag">作者</div>}
                            {
                              toUserName ?
                                <>
                                  <IconPlayArrowFill style={{ color: '#666666', marginRight: '4px' }} />
                                  <span className="to-user">{toUserName}</span>
                                </> : null
                            }
                          </div>
                          <div className="content-text">{child.text}</div>
                          {child.image_list && <div className="content-img"><img src={child.image_list?.[0]} alt="" /></div>}
                          <div className="content-operate">
                            <span className="content-time">{formatTime(child.create_time * 1000)} · {child.ip_label}</span>
                            <span className="reply" onClick={() => handleSingleReply(item, child)}>回复</span>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
                {
                  item.reply_comment_total ?
                    <>
                      {
                        (childList[item.cid]?.list?.length) ?
                          <>
                            {
                              childList[item.cid]?.has_more ?
                                <div className="comment-extend" style={{ marginLeft: mulpleFlag ? '90px' : '50px' }}>
                                  <div className="split"></div>
                                  <div className="split-name" onClick={() => handleExpandChild(item)}>展开更多</div>
                                  {expandLoading[item.cid] ? <Spin style={{ marginRight: '12px' }} /> : <IconDown style={{ marginRight: '12px' }} />}
                                  <div className="callpse" onClick={() => handleCollapse(item)}>
                                    <span>收起</span>
                                    <IconUp style={{ marginLeft: '5px' }} />
                                  </div>
                                </div> :
                                <div className="comment-extend" style={{ marginLeft: mulpleFlag ? '90px' : '50px' }}>
                                  <div className="split"></div>
                                  <div className="split-name" onClick={() => handleCollapse(item)}>收起</div>
                                  <IconUp />
                                </div>
                            }
                          </> :
                          <div className="comment-extend" style={{ marginLeft: mulpleFlag ? '90px' : '50px' }}>
                            <div className="split"></div>
                            <div className="split-name" onClick={() => handleExpandChild(item)}>展开{item.reply_comment_total}条回复</div>
                            {expandLoading[item.cid] ? <Spin /> : <IconDown />}
                          </div>
                      }
                    </>
                    : null
                }
              </div>
            )
          })
        }
        {
          !(dataSource.length) && <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {
              loading ? <Spin /> : <Empty />
            }
          </div>
        }
        {
          (dataSource.length && !hasMore) ?
            <div className="no-more">——已经是底线了——</div> : null
        }
      </div>
      <div className="chat-index-bottom">
        <div className="chat-input-wrapper">
          <div className="chat-input">
            <span className="comment-user">{singleFlag ? description : mulpleDesc}</span>
            <input
              value={textValue}
              onChange={e => setTextValue(e.target.value)}
              type="text"
              maxLength={300}
              onKeyDown={onKeyDown}
              ref={inputRef}
              disabled={!aweme_id}
            />
          </div>
          <div className={`send-btn ${aweme_id ? '' : 'disabled'}`} onClick={handleSend}>
            {sendLoading ? <Spin /> : <img
              src={msgImg}
              alt=""
            />}
            <span>发送</span>
          </div>
        </div>
      </div>
      <FormModal
        loading={confirmLoading}
        title={'提示'}
        visible={deleteVisible}
        icon={ModalTip}
        handCancel={() => { setDeleteVisible(false) }}
        submitHandle={() => {
          handleConfirmDelete()
        }}
      >
        <div style={{ padding: '26px 31px 0 61px', boxSizing: 'border-box' }}>
          <div style={{ fontSize: '16px', color: '#1D2129' }}>确定删除评论吗？</div>
          <div className="tip2">删除后数据不可恢复，请谨慎操作！</div>
        </div>
      </FormModal>
    </div>
  )
}
